"use client";;
import { FixLogoError_action } from "@/lib/actions/public.actions";
import { StaticImport, StaticRequire } from "next/dist/shared/lib/get-img-props";
import NextImage, { ImageProps, StaticImageData } from "next/image";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export default function Image(props: ImageProps) {
    const [img, setImg] = useState(props.src)
    const isStaticImport = (props.src as StaticImageData).height;

    let q = props.quality || 75;

    //reduce quality on dev for fater page loads
    if (process.env.NODE_ENV === 'development')
        q = 1;

    //auto update src on change
    useEffect(() => {
        setImg(props.src);
    }, [props.src])
    const maxDimension = Math.max(~~(props.width || 0), ~~(props.width || 0));
    const isToSmallToPlaceholder = maxDimension < 60 && maxDimension != 0;

    return <NextImage loading={ props.loading || props.priority && "eager" || "lazy" }
        quality={ q }
        unoptimized={ props.src.toString().endsWith(".gif") }
        placeholder={ !isToSmallToPlaceholder && (isStaticImport || !props.unoptimized) && "blur" || undefined }
        blurDataURL={ !isStaticImport && !props.unoptimized && `/_next/image?url=${img}&w=16&q=30` || undefined }
        onError={ () => {
            handleError(props.src, setImg)
        } }
        { ...props }
        src={ img }
    />
}

async function handleError(src: string | StaticImport, setImg: Dispatch<SetStateAction<string | StaticRequire | StaticImageData>>) {
    //set fallback 
    setImg("/favicon.ico")

    //ignore for static imports
    if (typeof src !== "string" || src.startsWith("/"))
        return;

    const url = new URL(src);
    const domain = url.hostname;

    //if domain is not youtube's
    if (!domain.startsWith("yt3"))
        return;

    //dont refetch logo's on dev server (making prod cache more up to date)
    if (process.env.NODE_ENV === 'development')
        return;


    const newUrl = await FixLogoError_action(src);
    //check errors
    if ("error" in newUrl)
        return console.warn("עדכון לוגו:", newUrl.error)

    setImg(newUrl.image);
}